/** True when the inclusive end date has passed (campaign no longer accepting pledges). */
export function isCampaignPastEndDate(endDate: string | null | undefined): boolean {
  if (!endDate) return false;
  const endDay = endDate.split('T')[0]!;
  const today = new Date().toISOString().split('T')[0]!;
  return today > endDay;
}

export function todayISO(): string {
  return new Date().toISOString().split('T')[0]!;
}
